import React, { createContext, ReactElement, useState, Dispatch, SetStateAction, useEffect } from "react";
import { cachearContexto } from "../../helpers/cachearContexto";
import ticketConclusaoTipoService from "../../services/TicketConclusaoTipoService";
import { TicketConclusaoTipo } from "./types";

interface ConclusaoTicketContextProps {
  listaMotivoConclusao: TicketConclusaoTipo[];
  setListaMotivoConclusao: Dispatch<SetStateAction<TicketConclusaoTipo[]>>
  handleAtualizarMotivoConclusao: (motivoConclusao:any, idMotivoMotivoConclusao?:number) => void;
  handleRemoveMotivoConclusao: (idMotivoMotivoConclusao:number) => void;
}

export const ConclusaoTicketContext = createContext({} as ConclusaoTicketContextProps);

export function ConclusaoTicketProvider({ children }: { children: ReactElement }) {
  const [listaMotivoConclusao, setListaMotivoConclusao] = useState<TicketConclusaoTipo[]>([] as TicketConclusaoTipo[]); 

  useEffect(()=>{
    cachearContexto(listaMotivoConclusao, setListaMotivoConclusao, ticketConclusaoTipoService.index)
  },[])

  const handleAtualizarMotivoConclusao = (motivoConclusao:any, idMotivoConclusao?:number) => {
    if(idMotivoConclusao){
      setListaMotivoConclusao((current) => {
        return ordenar(current.map((item) => {
           if(item?.id_ticket_conclusao_tipo === idMotivoConclusao){
             return motivoConclusao;
           }
           return item;
        }))
      })
    }else{
      setListaMotivoConclusao((current) => ordenar([motivoConclusao, ...current]));
    }
  }
  
  const ordenar = (motivos:TicketConclusaoTipo[]) => {
    return motivos.sort((a, b) => {return a.nome < b.nome ? 1 : -1})
  } 

  const handleRemoveMotivoConclusao = (idMotivoConclusao:number) => {
    setListaMotivoConclusao((current) => current.filter((item) => item.id_ticket_conclusao_tipo !== idMotivoConclusao));
  }

  return (
      <ConclusaoTicketContext.Provider
        value={{
          listaMotivoConclusao,
          setListaMotivoConclusao,
          handleAtualizarMotivoConclusao,
          handleRemoveMotivoConclusao
        }}
      >
          {children}
      </ConclusaoTicketContext.Provider>
  );
}
